import openSocket from 'socket.io-client';

export default openSocket('https://magicaonline.ensinio.cloud:6001');


